import { BIDService } from "./../../../../services/common/bid.service";
import { CIDService } from "./../../../../services/common/cid.service";
import { Component, OnInit, Inject } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from "@angular/forms";
import { MatSelect, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { IArea } from "src/app/interfaces/area";
import { ICity } from "src/app/interfaces/city";
import { IBranch } from "src/app/interfaces/Branch";
import { SoundEnum } from "src/app/enums/sound.enum";
import { TranslateService } from "@ngstack/translate";
import { IHolding } from "src/app/interfaces/holding";
import { IProvince } from "src/app/interfaces/province";
import { IPhoneType } from "src/app/interfaces/phoneType";
import { ErrorsService } from "src/app/services/common/errors.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { CityService } from "src/app/services/http/business/city/city.service";
import { AreaService } from "./../../../../services/http/business/area/area.service";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { PhoneTypeService } from "src/app/services/http/business/phoneType/phone-type.service";
import { ProvinceService } from "./../../../../services/http/business/province/provinces.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-Branch-entry",
  templateUrl: "./Branch-entry.component.html",
  styleUrls: ["./Branch-entry.component.css"]
})
export class BranchEntryComponent implements OnInit {
  cityList: ICity;
  areaList: IArea;
  form: FormGroup;
  holdingList: IHolding[];
  provinceList: IProvince;
  phoneTypeList: IPhoneType;
  ab: any;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  companyEncryptCode: string;

  constructor(
    private fb: FormBuilder,
    private cidService: CIDService,
    private bidService: BIDService,
    private cityService: CityService,
    private areaService: AreaService,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private BranchService: BranchService,
    private provinceService: ProvinceService,
    private phoneTypeService: PhoneTypeService,
    private dialogRef: MatDialogRef<BranchEntryComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.editCity(this.data.CityId);
  }

  ngOnInit() {
    this.createForm();
    if (typeof this.data === "string") {
      this.cidService.setCID(this.data);
    }
    if (typeof this.data === "object") {
      this.bidService.setBID(this.data.BranchEncryptId);
    }
  }
  createForm() {
    this.form = this.fb.group({
      Code: [
        this.data && this.data["Code"] ? this.data["Code"].toString() : null,
        Validators.compose([
          Validators.required,
          Validators.max(32767),
          Validators.min(1)
        ])
      ],
      Name: [
        this.data && this.data["Name"] ? this.data["Name"] : null,
        Validators.compose([Validators.maxLength(50), Validators.minLength(3)])
      ],
      BranchEncryptId: [
        this.data && this.data["BranchEncryptId"]
          ? this.data["BranchEncryptId"]
          : null
      ],
      Sexuality: [
        this.data && this.data["Sexuality"]
          ? this.data["Sexuality"].toString()
          : null,
        Validators.required
      ],
      DetailedAccounts: [
        this.data && this.data["DetailedAccounts"]
          ? this.data["DetailedAccounts"].toString()
          : null
      ],
      HasPermmissionExamDefine: [
        this.data && this.data.HasPermmissionExamDefine
          ? this.data.HasPermmissionExamDefine
          : false
      ],
      StatusName: [
        this.data && this.data["StatusName"] ? this.data["StatusName"] : null
      ],
      ProvinceId: [
        this.data && this.data["ProvinceId"]
          ? this.data["ProvinceId"].toString()
          : null
      ],
      // CityId: [
      //   this.data && this.data["CityId"] ? this.data["CityId"].toString() : null
      // ],
      AddressDto: this.fb.group({
        AreaId: [
          this.data &&
            this.data["AddressDto"] &&
            this.data["AddressDto"]["AreaId"]
            ? this.data["AddressDto"]["AreaId"].toString()
            : null,
          Validators.compose([Validators.required])
        ],
        CityId: [
          this.data &&
            this.data["AddressDto"] &&
            this.data["AddressDto"]["CityId"]
            ? this.data["AddressDto"]["CityId"].toString()
            : null,
          Validators.compose([Validators.required])
        ],
        Address: [
          this.data &&
            this.data["AddressDto"] &&
            this.data["AddressDto"]["Address"]
            ? this.data["AddressDto"]["Address"].toString()
            : null,
          Validators.compose([Validators.required, Validators.maxLength(250)])
        ],
        Longitude: [
          this.data &&
            this.data["AddressDto"] &&
            this.data["AddressDto"]["Longitude"]
            ? this.data["AddressDto"]["Longitude"].toString()
            : null
        ],
        Latitude: [
          this.data &&
            this.data["AddressDto"] &&
            this.data["AddressDto"]["Latitude"]
            ? this.data["AddressDto"]["Latitude"].toString()
            : null
        ],
        PostalCode: [
          this.data &&
            this.data["AddressDto"] &&
            this.data["AddressDto"]["PostalCode"]
            ? this.data["AddressDto"]["PostalCode"].toString()
            : null,
          [Validators.pattern("^[0-9]{10}?$")]
        ]
      }),
      ListPhone: this.fb.array([])
    });

    this.loadProvience();
    this.loadPhoneType();
    if (this.data && this.data["ProvinceId"]) {
      this.cityService.GetList(this.data["ProvinceId"]).subscribe(r => {
        this.cityList = r;

        if (this.data && this.data["AddressDto"]["CityId"]) {
          this.areaService.list(this.data["AddressDto"]["CityId"]).subscribe(e => {
            this.areaList = e;
            if (this.data && this.data["AddressDto"]["CityId"]) {
              this.areaService.list(this.data["AddressDto"]["CityId"], 0, 0).subscribe(s => {
                this.areaList = s;
              });
            }
          });
        }
      });
    }


    if (this.data && this.data.ListPhone) {
      this.initFormArray(this.data.ListPhone);
    } else {
      this.newForm();
    }
  }
  newForm() {
    const creds = this.form.controls.ListPhone as FormArray;
    creds.push(
      this.fb.group({
        GuidId: new FormControl(""),
        PhoneNumber: new FormControl(null, Validators.maxLength(11)),
        PhoneType: new FormControl(null, Validators.required)
      })
    );
  }

  editForm(list): FormGroup {
    let formGroup: FormGroup = new FormGroup({
      GuidId: new FormControl(list["GuidId"] ? list["GuidId"] : null),
      PhoneNumber: new FormControl(
        list["PhoneNumber"] ? list["PhoneNumber"] : null,
        Validators.maxLength(11)
      ),
      PhoneType: new FormControl(
        list["PhoneType"] ? list["PhoneType"].toString() : null,
        Validators.required
      )
    });
    return formGroup;
  }

  initFormArray(adresse) {
    if (adresse) {
      const formArray = this.form.get("ListPhone") as FormArray;
      adresse.map(item => {
        formArray.push(this.editForm(item));
      });
      this.form.setControl("ListPhone", formArray);
    }
  }

  loadProvience() {
    this.provinceService.GetList().subscribe(res => {
      this.provinceList = res;
    });
  }

  loadCity(element: MatSelect) {
    this.cityService.GetList(element.value).subscribe(res => {
      this.cityList = res;
    });
  }

  loadArea(element: MatSelect) {
    this.areaService.list(element.value).subscribe(res => {
      this.areaList = res;
    });
  }

  editCity(id: number) {
    this.cityService.GetList(id).subscribe(res => {
      this.ab = res;
    });
  }

  loadPhoneType() {
    this.phoneTypeService.list().subscribe(res => {
      this.phoneTypeList = res;
    });
  }

  addPhone(): void {
    (<FormArray>this.form.get("ListPhone")).push(
      new FormGroup({
        GuidId: new FormControl(""),
        PhoneNumber: new FormControl(
          null,
          Validators.compose([Validators.required, Validators.maxLength(11)])
        ),
        PhoneType: new FormControl(null)
      })
    );
  }
  removePhone(index: number) {
    if (index > 0) (<FormArray>this.form.get("ListPhone")).removeAt(index);
  }

  submit(form: IBranch) {
    this.errors = new Array();
    if (this.data && this.data.CompanyEncryptId) {
      this.BranchService.edit(form).subscribe(
        () => {
          this.onNoClick();
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    } else {
      this.BranchService.add(form).subscribe(
        () => {
          this.onNoClick();
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    }
  }

  onNoClick() {
    this.dialogRef.close();
  }

  // ngOnDestroy() {
  //   this.bidService.setBID("");
  // }
}
